// import React from 'react';
// import img1 from '../../assets/images/others/ladder14.jpeg';
// import img2 from '../../assets/images/others/grid3.jpeg';
// import img3 from '../../assets/images/others/grid5.jpeg';

// const WeHelpSection = ({ handleNavigation }) => {
//   return (
//     <div className="we-help-section py-12">
//       <div className="container mx-auto">
//         <div className="row flex justify-between">
//           <div className="col-lg-7 mb-5">
//             <div className="relative grid grid-cols-27 gap-4">
//               <div className="" data-aos="fade-left">
//                 <img src={img1} alt="Image 1" className="rounded-xl w-full" />
//               </div>
//               <div className=" pl-4" data-aos="fade-down">
//                 <img src={img2} alt="Image 2" className="rounded-xl w-full" />
//               </div>
//               <div className=" pt-5" data-aos="fade-up">
//                 <img src={img3} alt="Image 3" className="rounded-xl w-full" />
//               </div>
//             </div>
//           </div>
//           <div className="col-lg-5 flex flex-col justify-center items-start ps-lg-5" data-aos="fade-up" data-aos-duration="3000">
//             <h2 className="text-3xl font-bold mb-4">We Help You Make Modern Interior Design</h2>
//             <p className="mb-4">Yogesh Aluminum Ladders are precision-crafted using high-grade aluminum for lightweight strength, durability, and safety in various climbing applications.</p>
//             <ul className=" my-4 space-y-3">
//               <li className="relative pl-5">Aluminium Ladders</li>
//               <li className="relative pl-5">Aluminium Doors</li>
//               <li className="relative pl-5">Aluminium Partition</li>
//               <li className="relative pl-5">False Ceiling</li>
//               <li className="relative pl-5">Sliding Windows</li>
//             </ul>
//             <button onClick={handleNavigation} className=" px-5 py-3 bg-gray-800 text-white rounded hover:bg-gray-700">Explore</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WeHelpSection;




import React from 'react';

import img1 from '../../assets/images/others/ladder14.jpeg';
import img2 from '../../assets/images/others/grid3.jpeg';
import img3 from '../../assets/images/others/grid5.jpeg';
import svg from '../../assets/images/svg/dots-green.svg'

const WeHelpSection = ({ handleNavigation }) => {
  return (
    <>
      <section className="container mx-auto px-4 py-10 md:py-20">
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-8 items-center justify-center">
          {/* Image Grid */}
          

          <div className="relative flex items-center justify-center  lg:pl-8 ">
          <div className="flex flex-col items-end px-3 z-10">
            <img
              className=" mb-6 rounded-xl shadow-2xl h-28 sm:h-48 xl:h-56 w-28 sm:w-48 xl:w-56"
              src={img2}
              alt="product1"
            />
            <img
              className=" w-20 h-20 rounded-xl shadow-xl sm:h-32 xl:h-48 sm:w-32 xl:w-40"
              src={img3}
              alt="product2"
            />
          </div>
          <div className="px-3">
            <img
              className=" w-40 h-40 rounded-xl shadow-xl sm:h-64 xl:h-96 sm:w-64 xl:w-80"
              src={img1}
              alt="product3"
            />
          </div>

          <img src={svg} alt="dot's" className='absolute -bottom-6 left-0 opacity-10 lg:opacity-25 ' />
        </div>

          {/* Text Content */}
          <div className="text-content flex flex-col justify-center items-start " data-aos="fade-up" data-aos-duration="3000">
            <h2 className="text-3xl font-semibold text-[#182e55] mb-4">We Help You Make Modern Interior Design</h2>
            <p className="text-gray-500 mb-4">
              Yogesh Aluminum Ladders are precision-crafted using high-grade aluminum for lightweight strength, durability, and safety in various climbing applications.
            </p>

            <ul className=" my-4 space-y-3 text-gray-500 tracking-wider text-[15px]">
              <li className="relative pl-5 before:content-['o'] before:absolute before:left-0 before:text-stone-500 before:text-base before:font-medium flex items-center">Aluminium Ladders</li>
              <li className="relative pl-5 before:content-['o'] before:absolute before:left-0 before:text-stone-500 before:text-base before:font-medium flex items-center">Aluminium Doors</li>
              <li className="relative pl-5 before:content-['o'] before:absolute before:left-0 before:text-stone-500 before:text-base before:font-medium flex items-center">Aluminium Partition</li>
              <li className="relative pl-5 before:content-['o'] before:absolute before:left-0 before:text-stone-500 before:text-base before:font-medium flex items-center">False Ceiling</li>
              <li className="relative pl-5 before:content-['o'] before:absolute before:left-0 before:text-stone-500 before:text-base before:font-medium flex items-center">Sliding Windows</li>
            </ul>

            <button onClick={handleNavigation} className="px-5 py-2.5 bg-[#182e55] text-white rounded hover:bg-[#234279] mt-4">
              Explore
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default WeHelpSection;


